module.exports = __webpack_public_path__ + "static/media/wish-pressed-icon.a80754e1.svg";